import { IUserProfile } from '@/@types'
import CONSTANTS from '@/constants'

type GuestUserProfileSnapshot = Partial<
  Pick<IUserProfile, 'email' | 'first_name' | 'last_name' | 'recaptcha'>
> & {
  password?: string
}

const notifyStorageIssue = (error: unknown) => {
  if (process.env.NODE_ENV === 'production') return
  if (typeof window === 'undefined') return
  const supportsCustomEvent =
    typeof window.CustomEvent === 'function' || typeof CustomEvent === 'function'
  if (typeof window.dispatchEvent !== 'function' || !supportsCustomEvent) {
    return
  }
  const EventCtor =
    typeof window.CustomEvent === 'function'
      ? window.CustomEvent
      : (CustomEvent as typeof window.CustomEvent)
  window.dispatchEvent(new EventCtor('guest-user-storage-error', { detail: error }))
}

const getSessionStorage = (): Storage | null => {
  if (typeof window === 'undefined') return null
  try {
    return window.sessionStorage
  } catch {
    return null
  }
}

export const readGuestUserProfile = (): GuestUserProfileSnapshot | null => {
  const storage = getSessionStorage()
  if (!storage) return null
  try {
    const rawValue = storage.getItem(CONSTANTS.GUEST_USER_STORAGE_KEY)
    if (!rawValue) return null
    return JSON.parse(rawValue) as GuestUserProfileSnapshot
  } catch {
    storage.removeItem(CONSTANTS.GUEST_USER_STORAGE_KEY)
    return null
  }
}

export const persistGuestUserProfile = (profile: GuestUserProfileSnapshot) => {
  const storage = getSessionStorage()
  if (!storage) return
  try {
    storage.setItem(CONSTANTS.GUEST_USER_STORAGE_KEY, JSON.stringify(profile))
  } catch (error) {
    notifyStorageIssue(error)
  }
}

export const clearGuestUserProfile = () => {
  const storage = getSessionStorage()
  if (!storage) return
  try {
    storage.removeItem(CONSTANTS.GUEST_USER_STORAGE_KEY)
  } catch (error) {
    notifyStorageIssue(error)
  }
}
